/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEmailUnread = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M16.126 3a4.007 4.007 0 0 0 0 2H5.614L12 10.72l4.809-4.308c.405.535.942.966 1.562 1.242L12 13.28 4 6.216V19h16V8c.729 0 1.413-.195 2.001-.536L22 21H2V3zM20 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgEmailUnread as EmailUnread };
